<template>
  <div class="content">
    <!-- 顶部数据展示 -->
    <div class="content_top">
      <div class="count-item">
        <div class="item-content icon-all">
          <div class="item-num">{{(taskNumInfo.countNotFinish + taskNumInfo.countStart + taskNumInfo.countFinish+taskNumInfo.countOverdue+taskNumInfo.countFinishedOverdue) || 0}}</div>
          <el-tooltip :disabled="showTitle" offect="light" :content="$t('statistics.totalTasks')" placement="top">
            <div class="item-status" @mouseover="changeshowTitle($event)">{{$t("statistics.totalTasks")}}</div>
          </el-tooltip>
        </div>
      </div>
      <div class="count-item">
        <div class="item-content icon-not-start">
          <div class="item-num">{{taskNumInfo.countNotFinish || 0}}</div>
          <el-tooltip :disabled="showTitle" offect="light" :content="$t('projectDetailsV2.notBegin')" placement="top">
            <div class="item-status" @mouseover="changeshowTitle($event)">{{$t('projectDetailsV2.notBegin')}}</div>
          </el-tooltip>
        </div>
      </div>
      <div class="count-item">
        <div class="item-content icon-ongoing">
          <div class="item-num">{{taskNumInfo.countStart || 0}}</div>
          <el-tooltip :disabled="showTitle" offect="light" :content="$t('projectDetailsV2.inProgress')" placement="top">
            <div class="item-status" @mouseover="changeshowTitle($event)">{{$t('projectDetailsV2.inProgress')}}</div>
          </el-tooltip>
        </div>
      </div>
      <div class="count-item">
        <div class="item-content icon-completed">
          <div class="item-num">{{taskNumInfo.countFinish || 0}}</div>
          <el-tooltip :disabled="showTitle" offect="light" :content="$t('projectDetailsV2.completed')" placement="top">
            <div class="item-status" @mouseover="changeshowTitle($event)">{{$t('projectDetailsV2.completed')}}</div>
          </el-tooltip>
        </div>
      </div>
      <div class="count-item">
        <div class="item-content icon-overdue">
          <div class="item-num">{{taskNumInfo.countOverdue || 0}}</div>
          <el-tooltip :disabled="showTitle" offect="light" :content="$t('projectDetailsV2.overdue')" placement="top">
            <div class="item-status" @mouseover="changeshowTitle($event)">{{$t('projectDetailsV2.overdue')}}</div>
          </el-tooltip>
        </div>
      </div>
      <div class="count-item">
        <div class="item-content icon-Overduecompletion">
          <div class="item-num">{{taskNumInfo.countFinishedOverdue || 0}}</div>
          <el-tooltip :disabled="showTitle" offect="light" :content="$t('projectDetailsV2.overdueComplete')" placement="top">
            <div class="item-status" @mouseover="changeshowTitle($event)">{{$t('projectDetailsV2.overdueComplete')}}</div>
          </el-tooltip>
        </div>
      </div>
    </div>
    <div class="taskList">
      <myTaskList>
      </myTaskList>
    </div>
  </div>
</template>

<script>
import myTaskList from "./module/mytaskList/index"
import { taskNumber } from "@/services/myTask";

export default {
  name: "myTask",
  components: { myTaskList },
  data() {
    return {
      companyCode: "",
      taskNumInfo: {},      // 顶部数量
      showTitle: true,
    };
  },
  filters: {
    numFormat: function (value) {
      if (!value) return "0";
      value = value.toFixed(2);
      var intPart = Math.trunc(value); // 获取整数部分
      var intPartFormat = intPart
        .toString()
        .replace(/(\d)(?=(?:\d{3})+$)/g, "$1,"); // 将整数部分逢三一断
      var floatPart = "00";
      var value2Array = value.split(".");

      if (value2Array.length === 2) {
        floatPart = value2Array[1].toString();
        if (floatPart.length === 1) {
          return intPartFormat;
        } else {
          return intPartFormat;
        }
      } else {
        return intPartFormat;
      }
    }
  },
  mounted() {
    this.getNumber();
  },
  methods: {
    changeshowTitle(e) {
      let target = e.target;
      // 获取span 标签实际宽度 width+左右padding
      let textLength = target.clientWidth;
      // 获取 span 标签真实宽度 width=可视区域宽度+被隐藏区域宽度
      let containerLength = target.scrollWidth;
      if (textLength < containerLength) {
        this.tooltipTitle = e.target.innerText;
        this.showTitle = false;
      } else {
        this.showTitle = true;
      }
    },
    //顶部数量获取
    async getNumber() {
      const data = JSON.parse(localStorage.getItem("userInfo"));
      this.companyCode = data.companyList.code;
      this.userId = data.id;
      let params = {
        companyCode: this.companyCode,
        userId: this.userId
      };
      const res = await taskNumber(params);
      if (res.success) {
        if (!res.result) {
          return;
        }
        // countNotFinish     未开始
        // countStart         进行中
        // countFinish        已完成
        this.taskNumInfo = res.result;
      }
    },
  }
};
</script>

<style lang="less" scoped>
@import "./assets/style.less";
</style>